import {
  storyblokEditable,
  renderRichText,
  StoryblokComponent,
} from "@storyblok/react"
import { motion } from "framer-motion"
import whatYoullGet from "./WhatYoullGet.png"
import { Button } from "../../ui/button"

const listContainer = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.05 },
  },
}

export default function WhatYoullGet({ blok }: any) {
  const ctaHTML =
    renderRichText(blok?.ctaText || { content: [] })?.toString() || ""
  const ctaPlain = ctaHTML.replace(/<[^>]+>/g, "").trim()

  return (
    <section
      {...storyblokEditable(blok)}
      className="bg-white py-24 md:py-28 px-6 md:px-12"
    >
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 md:gap-14 items-start">
        <div>
          <div
            className="font-['BeausiteClassic'] font-bold text-[24px] md:text-[32px] text-gray-900 mb-3"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.heading || { content: [] }) || "",
            }}
          />
          <span className="block h-[3px] w-16 rounded-full bg-gradient-to-r from-[#4750F5] to-[#8BA3FF] mb-6" />

          <div
            className="font-['BeausiteClassic'] text-base md:text-lg text-gray-700 leading-relaxed mb-6"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.description || { content: [] }) || "",
            }}
          />

          <div className="relative max-w-2xl">
            <div className="absolute -left-3 top-6 bottom-6 w-2 rounded-full bg-gradient-to-b from-[#4750F5] to-[#8BA3FF]" />
            <img
              src={whatYoullGet}
              alt="What You’ll Get Preview"
              className="relative w-full rounded-2xl shadow-xl"
            />
          </div>
        </div>

        <motion.div
          variants={listContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="space-y-5 pt-24"
        >
          {blok.features?.map((nestedBlok: any) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
          {ctaPlain && blok?.ctaLink?.url && (
            <div className="pt-8">
              <Button asChild size="lg" variant="default">
                <a
                  href={blok.ctaLink.url}
                  target={blok.ctaLink.target || "_blank"}
                  rel="noopener noreferrer"
                >
                  {ctaPlain}
                </a>
              </Button>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  )
}
